export default __webpack_public_path__ + "static/Do-Nesting-b16ce88526d56c99df4b0894617c726dccc7d5f823ac4b1c249b79a4ef8f24b3.png";